import { AppSettingsConfig } from '../../../../../models/assets-data/AppSetttings.interface';


/**
 * Default application settings used as a fallback if fetching the assets file app-settings.json fails.
 * 
 * - Provides essential app configuration such as:
 *   - App name
 *   - Default navigation pages with titles, menu labels, URLs, and icons
 *   - A predefined set of icons used throughout the app
 * 
 * This ensures the app remains functional even if dynamic configuration retrieval fails.
 */
export const DEFAULT_ASSETS_APP_SETTINGS: AppSettingsConfig = {
  appSettings: {
        appName: "ReceivingMgr",
        appPages: [
          {
            pageTitle: "New Receiving Log Entry",
            menuTitle: "New Receiving Log Entry",
            url: "/receiving/new-log",
            icon: "create-outline"
          },
          {
            pageTitle: "Receiving Log",
            menuTitle: "View Receiving Logs",
            url: "/receiving/view-logs",
            
            icon: "folder-open-outline"
          },
          {
            pageTitle: "New Laydown Entry",
            menuTitle: "New Laydown Entry",
            url: "/laydown/new-log",
            icon: "create-outline"
          },
          {
            pageTitle: "Laydown Log",
            menuTitle: "View Laydown Logs",
            url: "/laydown/view-logs",
            icon: "folder-open-outline"
          },
          {
            pageTitle: "SOF Receiving",
            menuTitle: "SOF Receiving",
            url: "/sof-receiving",
            icon: "cube-outline"
          },
          {
            pageTitle: "SOF Receiving History",
            menuTitle: "SOF Receiving History",
            url: "/sof-receiving/history",
            icon: "folder-open-outline"
          }
        ],
        appIcons: [
          "createOutline",
          "listOutline",
          "print",
          "person",
          "create",
          "createOutline",
          "scan",
          "folderOpen",
          "folderOpenOutline",
          "imagesOutline",
          "cameraOutline",
          "barcode",
          "logOutOutline",
          "logInOutline",
          "swapVertical",
          "funnel",
          "personAdd",
          "open",
          "close",
          "checkmark",
          "mail",
          "closeCircle",
          "starOutline",
          "star",
          "help",
          "documentTextOutline",
          "warning",
          "refresh",
          "cubeOutline"
        ],
        emails: {
          expediting: "expediting.procurement@macmiller.com",
          itServiceDesk: "itservice.desk@macmiller.com",
          itServiceDeskCc: "phoenix.petterson@macmiller.com"
        }
      }
    };
      